/* eslint no-extend-native: [0, { "exceptions": ["Object"] }] */
String.prototype.replaceAll = () => {
  throw new Error('the function is disallowed in the project since its browser support (IE,older chrome ).');
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/configs/disallow.js
 **/